import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IComplaint } from 'app/models/compliance/complaint';
import { IAllegation } from 'app/models/compliance/allegation';
import { IIHCAgency } from 'app/models/compliance/ihc-agency';

@Injectable({providedIn: 'root'})
export class ComplaintService {

  public api: string = environment.privateApi + 'Complaint/';
  public http = inject(HttpClient);

  getComplaints(entityType: string, entityId: number): Observable<IComplaint[]> {
    return this.http.get<IComplaint[]>(this.api + 'GetComplaints/' + entityType + '/' + entityId);
  }

  updateComplaint(complaint: IComplaint): Observable<IComplaint> {
    return this.http.post<IComplaint>(this.api + 'UpdateComplaint', complaint);
  }

  createComplaint(): Observable<IComplaint> {
    return this.http.post<IComplaint>(this.api + 'CreateComplaint', null);
  }

  submitComplaint(complaint: IComplaint): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'SubmitComplaint', complaint);
  }

  deleteComplaint(complaintId: number): Observable<boolean> {
    return this.http.delete<boolean>(this.api + 'DeleteComplaint/' + complaintId);
  }

  getIHCAgencies(): Observable<IIHCAgency[]> {
    return this.http.get<IIHCAgency[]>(this.api + 'GetIHCAgencies');
  }

  getAllegation(allegationId: number): Observable<IAllegation> {
    return this.http.get<IAllegation>(this.api + 'GetAllegation/' + allegationId);
  }

  createAllegation(allegation: IAllegation): Observable<IAllegation> {
    return this.http.post<IAllegation>(this.api + 'CreateAllegation', allegation);
  }

  getAllegationsByComplaint(complaintId: number, includeArchived: boolean): Observable<IAllegation[]> {
    return this.http.get<IAllegation[]>(this.api + 'GetAllegationsByComplaint/' + complaintId + '/' + includeArchived);
  }

  updateAllegation(allegation: IAllegation): Observable<IAllegation> {
    return this.http.post<IAllegation>(this.api + 'UpdateAllegation', allegation);
  }

  archiveAllegation(allegationId: number, archive: boolean): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'ArchiveAllegation/' + allegationId + '/' + archive, null);
  }
}
